<template functional>
  <c-row>
    <c-col col="12" md="6">
      <c-card>
        <c-card-header>
          <c-icon name="cil-justify-center" />
          <strong>Bootstrap Badge</strong>
          <div class="card-header-actions">
            <a
              href="https://coreui.io/vue/docs/components/badge"
              class="card-header-action"
              rel="noreferrer noopener"
              target="_blank"
            >
              <small class="text-muted">docs</small>
            </a>
          </div>
        </c-card-header>
        <c-card-body>
          <h2>
            Example heading
            <c-badge color="primary">New</c-badge>
          </h2>
          <h3>
            Example heading
            <c-badge color="primary">New</c-badge>
          </h3>
          <h4>
            Example heading
            <c-badge color="primary">New</c-badge>
          </h4>
          <h5>
            Example heading
            <c-badge color="primary">New</c-badge>
          </h5>
          <h6>
            Example heading
            <c-badge color="primary">New</c-badge>
          </h6>
        </c-card-body>
        <c-card-footer>
          <c-button color="primary">
            Notifications
            <c-badge color="light" class="ml-2 position-static">4</c-badge>
          </c-button>
        </c-card-footer>
      </c-card>
    </c-col>
    <c-col col="12" md="6">
      <c-card>
        <c-card-header>
          <c-icon name="cil-justify-center" />
          Badge
          <small>contextual variations</small>
        </c-card-header>
        <c-card-body>
          <c-badge color="primary">Primary</c-badge>
          <c-badge color="secondary">Secondary</c-badge>
          <c-badge color="success">Success</c-badge>
          <c-badge color="danger">Danger</c-badge>
          <c-badge color="warning">Warning</c-badge>
          <c-badge color="info">Info</c-badge>
          <c-badge color="light">Light</c-badge>
          <c-badge color="dark">Dark</c-badge>
        </c-card-body>
      </c-card>
      <c-card>
        <c-card-header>
          <c-icon name="cil-justify-center" />
          Badge
          <small>shape="pill"</small>
        </c-card-header>
        <c-card-body>
          <c-badge shape="pill" color="primary">Primary</c-badge>
          <c-badge shape="pill" color="secondary">Secondary</c-badge>
          <c-badge shape="pill" color="success">Success</c-badge>
          <c-badge shape="pill" color="danger">Danger</c-badge>
          <c-badge shape="pill" color="warning">Warning</c-badge>
          <c-badge shape="pill" color="info">Info</c-badge>
          <c-badge shape="pill" color="light">Light</c-badge>
          <c-badge shape="pill" color="dark">Dark</c-badge>
        </c-card-body>
      </c-card>
      <c-card>
        <c-card-header>
          <c-icon name="cil-justify-center" />
          Badge
          <small>actionable</small>
        </c-card-header>
        <c-card-body>
          <c-badge href="#" color="primary">Primary</c-badge>
          <c-badge href="#" color="secondary">Secondary</c-badge>
          <c-badge href="#" color="success">Success</c-badge>
          <c-badge href="#" color="danger">Danger</c-badge>
          <c-badge href="#" color="warning">Warning</c-badge>
          <c-badge href="#" color="info">Info</c-badge>
          <c-badge href="#" color="light">Light</c-badge>
          <c-badge href="#" color="dark">Dark</c-badge>
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
</template>

<script>
export default {
  name: 'Badges',
};
</script>
